function SuspenseContent(){
    return(
        <div className="flex justify-center items-center h-screen">
            <progress className="progress w-56"></progress>
        </div>
    )
}

export default SuspenseContent